module.exports = __webpack_public_path__ + "static/img/emoji.6c21f2a1.svg";